<div class="container" style="overflow: auto;" >
  <div class="grid">
    <div class="col-5" style="padding-right: 1.25rem !important;">
      <div class="p-formgrid grid">
        <div class="field col-12">
          <label for="aufgabenart"  style="width: 10rem;">Aufgabenart</label>
          <p-select id="aufgabenart" [options]="aufgabenArten" [(ngModel)]="selectedAufgabenart" optionLabel="value"
            [disabled]="!canSelectAufgabenArt()" placeholder="Aufgabenart wählen" (ngModelChange)="changedAufgabenart()"
            [style]="{'max-width': '15rem', 'width': '15rem'}">
          </p-select>
        </div>

        @if (canselectEinkauf(selectedAufgabenart)) {
          <div class="field col-12">
            <label for="einkauf"  style="width: 10rem;">Einkauf</label>
            <p-select id="einkauf" [options]="einkaeufe$ | async" [(ngModel)]="selectedEinkauf" optionLabel="name"
              [disabled]="!hasValidEinkauf(selectedEinkauf)" placeholder="Einkauf wählen" (ngModelChange)="changedEinkauf()"
              [style]="{'max-width': '15rem', 'width': '15rem'}">
            </p-select>
          </div>
        }


        @if (canKlammer()) {
          <div class="field col-12">
            <label for="klammer"  style="width: 10rem;">Sortimentsklammer</label>
            <p-select id="klammer" [options]="sortimentsKlammern$ | async" optionLabel="name"
              [(ngModel)]="selectedKlammer" placeholder="Sortimentsklammer wählen"
              (ngModelChange)="filterSortimentByMaster()" [style]="{'max-width': '15rem', 'width': '15rem'}">
            </p-select>
          </div>
        }

        @if (canSortimentsTypen()) {
          <div class="field col-12">
            <label for="typeInfoBox"  style="width: 10rem;">Sortimentstyp</label>
            <p-select id="typeInfoBox" [options]="sortimentsTypen$ | async" optionLabel="name"
              [style]="{'max-width': '15rem', 'width': '15rem'}" showClear="true" placeholder="Filter auswählen"
              [(ngModel)]="selectedType" (ngModelChange)="setSortimentType()">
            </p-select>
          </div>
        }
        @if (editMode == 'edit' && canSortiment()) {
          <div class="field col-12 ">
            <label for="selectSortiment"  style="width: 10rem;">Sortiment</label>
            <p-select id="selectSortiment" [options]="sortimentsToView$ | async" optionLabel="name"
              [style]="{'max-width': '15rem', 'width': '15rem'}" placeholder="Sortiment wählen"
              [(ngModel)]="selectedSortiment" filter="true"
              [disabled]="((sortimentsToView$ | async) === null || (selectedKlammer == null))">
            </p-select>
          </div>
        }
        @if (targetType == 'master' && editMode == 'new' && canSortiment() ) {
          <div class="field col-12 ">
            <label for="selectSortiments"  style="width: 10rem;">Sortimente</label>
            <p-multiSelect id="chooseSortiment" [options]="sortimentsToView$ | async"
              selectedItemsLabel="{0} Sortimente ausgewählt"
              [disabled]="((sortimentsToView$ | async) === null || (selectedKlammer == null))"
              placeholder="Sortiment wählen" [(ngModel)]="selectedSortimentsForMaster" optionLabel="name"
              [style]="{'max-width': '15rem', 'width': '15rem'}">
            </p-multiSelect>
          </div>
        }
        @if (canSelectList()) {
          <div  class=" grid  col-12 ">
            <div class="field col-3" style="padding-bottom: 0.2rem;">
              <p-checkbox id="withUpload" [(ngModel)]="taskModel.includeUpload" binary="true" ></p-checkbox>
              <label class="ml-2"  for="withUpload" >Liste</label>
            </div>
            <div class="field col-9">
              <p-select id="validationSelection" [options]="validationProfiles$ | async" optionLabel="listName"
                placeholder="Listenart angeben" [(ngModel)]="selectedList" (ngModelChange)="setValidationList()"
              [style]="{'max-width': '18rem', 'width': '18rem'}"></p-select>
            </div>
            <div class="field col-6 grid">
              <label for="minCount"class="col-12 w-full " >Minimum</label>
              <div class="col-6">
                <p-inputNumber inputStyleClass="w-8rem"  id="minCount"  [(ngModel)]="taskModel.min" [showButtons]="true"></p-inputNumber>
              </div>
            </div>
            <div class="field col-6 grid" >
              <label for="maxCount" class="col-12 w-full" >Maximum</label>
              <div class="col-10 ">
                <p-inputNumber inputStyleClass="w-8rem"  id="maxCount" [(ngModel)]="taskModel.max" [showButtons]="true"></p-inputNumber>
              </div>
            </div>
            @if (canLoadSortimentArtikel(taskModel)) {
              <div class="field col-12">
                <div class="flex flex-wrap gap-3">
                  <div class="flex align-items-center">
                    <p-checkbox id="loadSortimentArtikel" [(ngModel)]="taskModel.loadSortimentArtikel" binary="true" [disabled]="disableCanLoadSortimentArtikel(taskModel)"
                    for="loadSortimentArtikelLabel"></p-checkbox>
                    <label  class="ml-2" id="loadSortimentArtikelLabel" >Artikel aus Sortimentieren laden</label>
                  </div>
                </div>
              </div>
            }
            @if (canLoadLieferantType(taskModel)) {
              <div class="col-12">
                <div class="flex flex-wrap gap-3">
                  <div class="flex align-items-center">
                    <p-radiobutton [disabled]="disableCanLoadSortimentArtikel(taskModel)"
                      name="lieferant"
                      value="1"
                      [(ngModel)]="taskModel.lieferantType"
                      [attr.aria-checked]="taskModel.lieferantType == 1"
                      inputId="lieferant" />
                    <label for="lieferant" class="ml-2">
                      Lieferant
                    </label>
                  </div>
                  <div class="flex align-items-center">
                    <p-radiobutton [disabled]="disableCanLoadSortimentArtikel(taskModel)"
                      name="cm"
                      value="2"
                      [(ngModel)]="taskModel.lieferantType"
                      [attr.aria-checked]="taskModel.lieferantType == 2"
                      inputId="cm" />
                    <label for="cm" class="ml-2">
                      Category Captain
                    </label>
                  </div>
                </div>
              </div>
            }
          </div>
        }
      </div>
    </div>
    <div class="col-7" style="padding-left: 1.25rem !important; border-left: 1px solid lightgray !important;">
      <div class="p-fluid p-formgrid grid">
        <div class="field col-12">
          <label for="taskText">Aufgabentext</label>

          <p-select id="taskText" [options]="taskInfoTexts" [(ngModel)]="taskModel.name"
          placeholder="Wählen Sie einen Aufgabentext" editable="true" [style]="{'width': '100%'}"></p-select>
        </div>
        <div class="field col-12 formAreaSeparatorBottom">
          <label for="taskDescription">Beschreibung</label>
          <textarea pTextarea  style="width: 100%;" id="taskDescription" type="text" [(ngModel)]="taskModel.taskDescription" rows="4"
          cols="80" pTextarea autoResize="autoResize"></textarea>
        </div>
        <div class="field col-6 p-md-6">
          <label for="laufzeit" style="width: 4rem;">Laufzeit</label>
          <p-datepicker id="laufzeit" [(ngModel)]="taskModel.taskActiveRange" [firstDayOfWeek]="1" dateFormat="dd.mm.yy"
            appendTo="body" selectionMode="range" showButtonBar="true" [showIcon]="true"
          (onSelect)="onSelectValidRange($event)" (onInput)="onInputValidRange($event)"></p-datepicker>
        </div>
        <div class="field col-6 p-md-6">
          <label for="bearbeitungszeit">Bearbeitung</label>
          <p-datepicker id="bearbeitungszeit" [(ngModel)]="taskModel.taskValidRange" [firstDayOfWeek]="1"
            dateFormat="dd.mm.yy" appendTo="body" selectionMode="range" showButtonBar="true"
          [showIcon]="true"></p-datepicker>
        </div>
        <div class="field col-6 formAreaSeparatorTop">
          <div class="flex flex-wrap gap-3">
            <div class="flex align-items-center">

              <p-checkbox id="withInvite" [(ngModel)]="taskModel.sendInvite" binary="true" for="Einladen"></p-checkbox>
              <label  class="ml-2" id="Einladen" >Einladen</label>
            </div>
          </div>
        </div>
        <div class="field col-6 formAreaSeparatorTop">
          <p-datepicker id="einladung" [(ngModel)]="taskModel.invitationDate" [firstDayOfWeek]="1" dateFormat="dd.mm.yy"
          appendTo="body" showButtonBar="true" [showIcon]="true"></p-datepicker>
        </div>
        @if (taskModel.sendInvite) {
          <div class="field col-4">
            <div class="flex flex-wrap gap-3">
              <div class="flex align-items-center">
                <p-checkbox id="withInviteOne" [(ngModel)]="taskModel.sendInviteOne" [disabled]="!taskModel.sendInvite"
                binary="true" for="Erinnerung1"></p-checkbox>
                <label  class="ml-2" id="Erinnerung1" >Erinnerung 1</label>
              </div>
            </div>
          </div>
        }
        @if (taskModel.sendInvite) {
          <div class="field col-4">
            <div class="flex flex-wrap gap-3">
              <div class="flex align-items-center">
                <p-checkbox id="withInviteTwo" [(ngModel)]="taskModel.sendInviteTwo" [disabled]="!taskModel.sendInviteOne"
                binary="true" for="Erinnerung2"></p-checkbox>
                <label  class="ml-2" id="Erinnerung2" >Erinnerung 2</label>
              </div>
            </div>
          </div>
        }
        @if (taskModel.sendInvite) {
          <div class="field col-4">
            <div class="flex flex-wrap gap-3">
              <div class="flex align-items-center">
                <p-checkbox id="withInviteThree" [(ngModel)]="taskModel.sendInviteThree" [disabled]="!taskModel.sendInviteTwo"
                binary="true" ></p-checkbox>
                <label  class="ml-2" id="withInviteThree" >Erinnerung 3</label>
              </div>
            </div>
          </div>
        }
        @if (taskModel.sendInvite) {
          <div class="field col-4">
            <p-datepicker id="inviteone" [(ngModel)]="taskModel.dateInviteOne" [disabled]="!taskModel.sendInviteOne"
              [firstDayOfWeek]="1" dateFormat="dd.mm.yy" appendTo="body" showButtonBar="true"
            [showIcon]="true"></p-datepicker>
          </div>
        }
        @if (taskModel.sendInvite) {
          <div class="field col-4">
            <p-datepicker id="invitetwo" [(ngModel)]="taskModel.dateInviteTwo" [disabled]="!taskModel.sendInviteTwo"
              [firstDayOfWeek]="1" dateFormat="dd.mm.yy" appendTo="body" showButtonBar="true"
            [showIcon]="true"></p-datepicker>
          </div>
        }
        @if (taskModel.sendInvite) {
          <div class="field col-4">
            <p-datepicker id="invitethree" [(ngModel)]="taskModel.dateInviteThree" [disabled]="!taskModel.sendInviteThree"
              [firstDayOfWeek]="1" dateFormat="dd.mm.yy" appendTo="body" showButtonBar="true"
            [showIcon]="true"></p-datepicker>
          </div>
        }
      </div>
    </div>
  </div>
  <!-- Show Upload-Control only - if Record is new and MasterTask -->
  @if (editMode == 'new' && targetType == 'master') {
    <div class="p-formgrid grid formAreaSeparatorTop">
      <h3>Angehängte Dateien</h3>
      <div class="field col-12">
        <p-fileUpload #fubautoNew name="uploadFiles[]" invalidFileTypeMessageSummary="{0} Datei nicht erlaubt"
          chooseLabel="Neu..." multiple="multiple" fileLimit="5" invalidFileLimitMessageSummary="Maximal 5 Dateien erlaubt"
          accept=".xlsx,.jpg,.png,.pdf" maxFileSize="1000000" customUpload="true" (uploadHandler)="uploadFiles($event)"
          mode="advanced" previewWidth="30" auto="true">
          <ng-template let-file pTemplate="file">
            <div class="p-row row">
              <div style="word-wrap: break-word;" class="col-6">{{ file.name }}</div>
              <div style="word-wrap: break-word;" class="col-4">{{ file.type }}</div>
              <div class="col-2">
                <button pButton type="button" icon="pi pi-trash" class="p-button-secondary"
                (click)="removeFile(file)"></button>
              </div>
            </div>
          </ng-template>
        </p-fileUpload>
      </div>
    </div>
  }
  <!-- Show List of Uploads and Upload Control when editing, needed for master and supplier tasks -->
  @if (editMode == 'edit') {
    <div class="p-formgrid grid">
      <div class="field col-12 p-md-6">
        <label for="fileTable">Vorhandene Dateien</label>
        <p-table id="fileTable" [value]="getVorhandeneDateien()" scrollHeight="150px" [scrollable]="true" showGridlines="true" >
          <ng-template pTemplate="header">
            <tr>
              <th [ngClass]="'kb-header-cell-default'">Datei</th>
              <th [ngClass]="'kb-header-cell-default'">Typ</th>
              <th [ngClass]="'kb-header-cell-small'"><i class="pi pi-trash"></i></th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-rowData let-ri="rowIndex">
            <tr [pSelectableRow]="rowData">
              <td [ngClass]="'kb-cell-default'">{{ rowData.fileName }}</td>
              <td [ngClass]="'kb-cell-default'">{{ rowData.fileType }}</td>
              <td [ngClass]="'kb-cell-small'">
                <button pButton type="button" icon="pi pi-trash" class="p-button-secondary"
                (click)="removeExistingFile(rowData)"></button>
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>
      <div class="field col-12 p-md-6">
        <label for="newUploads">Weitere Dateien</label>
        <p-fileUpload id="newUploads" #fubauto name="uploadFiles[]" invalidFileTypeMessageSummary="{0} Datei nicht erlaubt"
          chooseLabel="Neu..." multiple="multiple" fileLimit="5" invalidFileLimitMessageSummary="Maximal 5 Dateien erlaubt"
          accept=".xlsx,.jpg,.png,.pdf" maxFileSize="1000000" customUpload="true" (uploadHandler)="uploadFiles($event)"
          mode="advanced" previewWidth="30" auto="true">
          <ng-template let-file pTemplate="file">
            <div class="p-row row">
              <div style="word-wrap: break-word;" class="col-6">{{ file.name }}</div>
              <div style="word-wrap: break-word;" class="col-4">{{ file.type }}</div>
              <div class="col-2">
                <button pButton type="button" icon="pi pi-trash" class="p-button-secondary"
                (click)="removeFile(file)"></button>
              </div>
            </div>
          </ng-template>
        </p-fileUpload>
      </div>
    </div>
  }
  <div class="grid formAreaSeparatorTop">
    <div class="field col-2">
      <button pButton [disabled]="!canSave()" label="Speichern" class="p-button-info" (click)="saveTask(false)"></button>
    </div>
    @if (canSavewithLieferanten()) {
      <div class="field col-4">
        <button pButton label="Speichern auch für Lieferanten" class="p-button-info"
        (click)="saveTaskwithChildren()"></button>
      </div>
    }
    <div class="field col-2">
      <p-button severity="info" label="Beenden"  (click)="close()"></p-button>
    </div>
  </div>


  <p-toast id="taskedittoasterSuccess"  key="successtaskMessage" (onClose)="clearMessages()"></p-toast>
  <p-toast id="taskedittoasterError"  key="errortaskMessage" (onClose)="clearMessages()"></p-toast>


  <p-confirmDialog appendTo="body" header="Bitte bestätigen:" icon="pi pi-exclamation-triangle" message="nix"
    rejectLabel="Abbrechen">
  </p-confirmDialog>

</div>

